import React from "react";

const AdsConsentTerms = () => {
  return (
    <div className="content">
      <p>
        주식회사 아이나비시스템즈는 고객님께서 수집 및 이용에 동의한 개인정보를
        이용하여 SMS(MMS), SNS 메시지, 이메일, 푸시 알림 등 다양한 전자적 전송
        매체를 통해 오전 8시부터 오후 9시까지 개인 맞춤형 광고 및 정보를 전송할
        수 있습니다.
      </p>
      <p>
        본 동의는 거부하실 수 있으나, 거부 시 이벤트 및 프로모션 안내, 유용한
        광고를 받아보실 수 없습니다.
      </p>
      <table>
        <tbody>
          <tr>
            <td width="301">
              <p>마케팅 및 홍보 수신 방법</p>
            </td>
            <td width="301">
              <p>□문자&nbsp; &nbsp;&nbsp;□이메일</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>※ 광고성정보수신의 변경</p>
      <p>
        1) SMS, 이메일: 웹 브라우저 INAVI Maps에 로그인 &gt; 회원정보 &gt; 마케팅 수신
        동의 &gt; 수정
      </p>
      <p>2) SNS: 각 SNS의 설정 내 수신 차단 메뉴</p>
    </div>
  );
};

export default AdsConsentTerms;
